<template>
    <component :is="config.public.websiteId === 'spm' ? SPM : SBE">
        <slot />
    </component>
</template>

<script setup>
import SPM from '~/layouts/spm.vue';
import SBE from '~/layouts/sbe.vue';
const config = useRuntimeConfig();

import { useHead } from '#imports'
import {useFavicon} from "~/composables/useFavicon";

useHead({
    bodyAttrs: {
        class: [config.public.websiteId, 'h-100']
    }
})

useFavicon();
</script>
